export const checkKeyDown = (event) => {
  if(event.code === 'Enter' && event.target.id === 'comment')
    event.preventDefault();
}